import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'

countries.registerLocale(en)

export default {
    install(Vue) {
        Vue.prototype.$countries = countries
    }
}
